import { useAppContext } from "@pagegrowler_nextjs";

export const useHome = (props) => {

  const { content, landing ,...rest } = props;
  const menu = rest?.menu ?? {};
  const preview = rest?.preview ?? false;
  const isPreview = rest?.preview ?? false;

  const pg = useAppContext();
  const Pagegrowler = pg?.pagegrowler;
  Pagegrowler?.setWidgetsLayout(rest?.widgetList);

  const metaRefresh = rest?.meta?.filter(
    (metatags) => metatags.meta == "refresh"
  );

  const title = landing?.title ?? "";

  const dataAnalitics = {
    sections: "home",
    section: "",
    pageType: "Home",
    nsSite: "clarin80",
    name: "home.inicio",
    publishedDate: landing?.modificatedAt ?? new Date(),
  };

  const dataMeter = {
    pageType: "portada",
    section: "home",
    paywall: "free",
    category: "home",
  };
  
  let sectionNameAds = "home";
  let sectionName = ""
  let h1MainTitle = "CLARÍN 80 ANIVERARIO";

  const adsPath = landing?.url != "/" ? landing?.url?.split("/")[1]+"/home" : "home";

  const metaDescription = rest?.meta?.find((meta) => meta.meta == "description" && meta.type == "name")?.value || "";

  return {
    ...rest,
    menu,
    preview,
    isPreview,
    Pagegrowler,
    formatContent: {
      dataAnalitics,
      dataMeter,
      adsPath,
      sectionNameAds,
      h1MainTitle,
      metaRefresh: {
        status: metaRefresh?.[0]?.value != "0",
        timer:
          metaRefresh?.[0]?.value && !isNaN(metaRefresh?.[0]?.value)
            ? metaRefresh[0].value
            : 300,
      },
      dataMetaTagsSubhome: {
        title,
        section: sectionName,
        url: "clarin80",
        metaDescription,
      },
      
      
    },
  };
};
